module.exports = __webpack_public_path__ + "img/bojLogo.89caecd1.jpeg";